import * as React from 'react';

import * as styles from './styles.css';

type TLayoutUserCardActions = {
  actions: React.ReactNode[];
  menu: React.ReactNode | null;
};

export const UserCardActions: React.FC<TLayoutUserCardActions> = ({ actions, menu }) => {
  const items = React.useMemo(
    () => actions.map((action, index) => <div key={`action_row_${index}`}>{action}</div>),
    [actions],
  );

  if (!items.length && !menu) {
    return null;
  }

  return (
    <div className={styles['actions']}>
      {items}
      {menu}
    </div>
  );
};
